export default __webpack_public_path__ + "static/media/business-logo.6df69a25.svg";